<template>
  <svg v-if="mode === 'flush'" width="41" height="13" viewBox="0 0 41 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.63477 11.2598H37.6348" :stroke="color" stroke-width="0.6" stroke-dasharray="2 2"/>
    <path d="M20.448 5.5H11" :stroke="color"/>
    <path d="M34.448 5.5H25" :stroke="color"/>
  </svg>

  <svg v-else-if="mode === 'east-west'" width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.79907 8.71368L14.1267 4.45215L18.9202 8.7272M21.5837 8.7272L26.9106 4.45215L31.7041 8.7272" :stroke="color" stroke-width="0.75"/>
    <path d="M4.92822 12.7598H34.9282" :stroke="color" stroke-width="0.6" stroke-dasharray="2 2"/>
  </svg>

  <svg v-else-if="mode === 'fixed-tilt'" width="30" height="17" viewBox="0 0 30 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 12.877H30" :stroke="color" stroke-width="0.6" stroke-dasharray="2 2"/>
    <path d="M7 9.37444L11.532 0.876953M13.2315 9.37444L17.7635 0.876953M19.463 9.37444L23.995 0.876953" :stroke="color" stroke-width="0.75"/>
  </svg>
</template>

<script>
export default {
  name: "MountingTypeIcon",
  props: {
    mode:  { type: String, required: true }, // 'flush' | 'east-west' | 'fixed-tilt'
    color: { type: String, default: "white" },
  },
};
</script>
